/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "a872ee9b725b4adbb2cdde96bf37b175",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "a872ee9b725b4adbb2cdde96bf37b175",
            "region": "us-east-1"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://r2r74v3vmzhrrhrakoyddzzypq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "FireboltWebsiteAPIs",
            "endpoint": "https://pwnz7afd7c.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:0a50ff61-b190-40b5-badb-0b67ac970e79",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_uvUsAESHc",
    "aws_user_pools_web_client_id": "3f2p4univci8mcj8d6u7sj4sp9",
    "oauth": {
        "domain": "firebolt-midwayauth-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://irisfirebolt.gsf.amazon.dev/,https://beta.irisfirebolt.gsf.amazon.dev/,https://dev-dsk-gmandavy-1e-7cf5565d.us-east-1.amazon.com:3000/,https://dev.irisfirebolt.gsf.amazon.dev/",
        "redirectSignOut": "https://irisfirebolt.gsf.amazon.dev/,https://beta.irisfirebolt.gsf.amazon.dev/,https://dev-dsk-gmandavy-1e-7cf5565d.us-east-1.amazon.com:3000/,https://dev.irisfirebolt.gsf.amazon.dev/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "gsf-firebolt-app-files212421-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "FireBoltCalculations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "FireBoltConfig-dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
